export default __webpack_public_path__ + "static/media/krefeld_dark.27d6176a.png";